import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { readAdsConsent, setAdsConsent } from '../../lib/ads';
export default function CookieConsent() {
  const [visible, setVisible] = useState(() => !readAdsConsent());
  const choose = (accepted: boolean) => { setAdsConsent(accepted); setVisible(false); };
  useEffect(() => {
    const open = () => setVisible(true);
    window.addEventListener('open-cookie-preferences', open);
    return () => window.removeEventListener('open-cookie-preferences', open);
  }, []);
  if (!visible) return null;
  return <section aria-label="Preferências de cookies" className="fixed bottom-28 md:bottom-4 right-4 z-[60] max-w-sm w-[calc(100%-2rem)] bg-white border-l-4 border-segredo-yellow shadow-2xl rounded-sm p-4">
    <p className="text-sm text-gray-700">Com a sua autorização, usamos cookies do Google Ads para medir os contactos provenientes dos anúncios. Pode recusar e continuar a ligar ou usar o WhatsApp. <Link to="/politica-cookies" className="underline">Política de Cookies</Link>.</p>
    <div className="flex gap-3 mt-4"><button onClick={() => choose(false)} className="flex-1 border border-gray-400 rounded py-3 text-sm">Recusar</button><button onClick={() => choose(true)} className="flex-1 bg-segredo-yellow text-segredo-black rounded py-3 text-sm font-bold">Aceitar medição</button></div>
  </section>;
}
